import React from 'react';
import './LoginPage.css';
import LoginPage from '../../Components/PageComponents/UserLogin/LoginPage';
import HeaderSec from '../../Components/HeaderSec/HeaderSec';
import FooterComp from '../../Components/FooterComp/FooterComp';

const MainLoginPage = () => {
    

    return (
        <div className=' overflow-hidden'>
            <HeaderSec theme={"light"} />
            <LoginPage/>
            <FooterComp theme={"light"} />
        </div>
    );
}

export default MainLoginPage;
